import { fetchAllProjectsThunk } from './fetchAllProjectsThunk';
export default fetchAllProjectsThunk;
